import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";

const WorkingHoursItem = ({
  day,
  start_time,
  end_time,
  is_active,
  setWorkingHours,
  isWorkHour,
}) => {
  const [stime, setSTime] = useState(start_time);
  const [etime, setETime] = useState(end_time);
  const [active, setActive] = useState(is_active);

  useEffect(() => {

    if(!isWorkHour){
      setWorkingHours((prev) => {
        const d = prev.findIndex((item) => item.day === day);
        prev[d].is_active = false;
        setActive(prev[d].is_active);
        return prev;
      });
    }
  }, [isWorkHour]);

  const handleStartTime = (value) => {
    if(isWorkHour){
      setSTime(value);
      setWorkingHours((prev) => {
        const d = prev.findIndex((item) => item.day === day);
        prev[d].start_time = moment(value).format("HH:mm");
        prev[d].end_time = moment(value).add(9, "hours").format("HH:mm");
        setETime(prev[d].end_time);
        return prev;
      });
    }
  };

  const handleEndTime = (value) => {
    if(isWorkHour){
      setETime(value);
      setWorkingHours((prev) => {
        const d = prev.findIndex((item) => item.day === day);
        prev[d].end_time = moment(value).format("HH:mm");
        return prev;
      });
    }
  };

  const handleDaySelection = () => {
    setActive(!active);
    setWorkingHours((prev) => {
      const d = prev.findIndex((item) => item.day === day);
      prev[d].is_active = !prev[d].is_active;

      // if (!prev[d].is_active) {
      //   prev[d].start_time = null;
      //   prev[d].end_time = null;
      //   setSTime(prev[d].end_time);
      //   setETime(prev[d].end_time);
      // }

      return prev;
    });
  };

  return (
    <div className="w-1/2 xxs:w-full flex flex-row items-center space-x-4">
      <div>
        <div
          className={`h-[50px] w-[50px] flex justify-center items-center ${
            isWorkHour ? "cursor-pointer" : "cursor-not-allowed"
          }  ${
            active
              ? "bg-[--bg-color-500]"
              : "bg-[--bg-color-50] border border-[--bg-color-100]"
          }  rounded-full xxs:mr-1 mr-4`}
          onClick={(e) => {
            e.stopPropagation();
            if(isWorkHour) handleDaySelection();
          }}
        >
          <span
            className={`font-inter font-semibold text-sm uppercase ${
              active ? "text-white" : "text-[#535860]"
            } `}
          >
            {day[0]}
          </span>
        </div>
      </div>
      <div className="relative">
        <Flatpickr
          options={{
            disableMobile: true,
            enableTime: true,
            noCalendar: true,
            dateFormat: "h:i K",
            time_24hr: false,
          }}
          value={stime}
          onChange={(selectedTime) => {
            handleStartTime(selectedTime[0]);
          }}
          className="form-input truncate disabled:border-slate-200 px-2 w-full flatpickr-disabled"
          placeholder="Select Start Time"
          disabled={!active}
          style={{
            background: !active ? "#F5F5F5" : "white",
            cursor: !active ? "no-drop" : "pointer",
          }}
        />
        <span className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
          <i className="fa-regular fa-clock text-[#737373]"></i>
        </span>
      </div>

      <div className="relative">
        <Flatpickr
          options={{
            disableMobile: true,
            enableTime: true,
            noCalendar: true,
            dateFormat: "h:i K",
            time_24hr: false,
          }}
          value={etime}
          onChange={(selectedTime) => handleEndTime(selectedTime[0])}
          className={`form-input truncate disabled:border-slate-200 px-2 w-full`}
          placeholder="Select End Time"
          disabled={!active}
          style={{
            background: !active ? "#F5F5F5" : "white",
            cursor: !active ? "no-drop" : "pointer",
          }}
        />
        <span className="absolute inset-y-0 right-2 flex items-center pointer-events-none">
          <i className="fa-regular fa-clock text-[#737373]"></i>
        </span>
      </div>
    </div>
  );
};

export default WorkingHoursItem;
